export const classification = [
  {
    name: 'SEGURANÇA',
    value: 'segurança'
  },
  {
    name: 'SAÚDE',
    value: 'saude'
  },
  {
    name: 'MEIO AMBIENTE',
    value: 'meio_ambiente'
  }
]

export const frequency = [
  {
    name: 'FREQUENTE',
    value: 'frequente'
  },
  {
    name: 'OCASIONAL',
    value: 'ocasional'
  },
  {
    name: 'RARO',
    value: 'raro'
  }
]

export const gravity = [
  {
    name: 'BAIXA',
    value: 'baixa'
  },
  {
    name: 'MODERADA',
    value: 'moderada'
  },
  {
    name: 'ALTA',
    value: 'alta'
  }
]

export const riscoComport = [
  {
    name: 'Não utilização das faixas de pedestres ou corredores',
    value: 'faixas_e_corredores'
  },
  {
    name: 'Atenção ao trajeto (ex: uso do celular ao caminhar)',
    value: 'trajeto'
  },
  {
    name: 'Ausência ou procedimento de trabalho inadequado',
    value: 'procedimento'
  },
  {
    name: 'Desrespeito a sinalização',
    value: 'sinalizacao'
  },
  {
    name: 'Esforço físico superior a sua capacidade física',
    value: 'esforco'
  },
  {
    name: 'Executar tarefa sem bloqueio',
    value: 'sem_bloqueio'
  },
  {
    name: 'Falta de atenção na tarefa (ex: brincadeiras)',
    value: 'atencao'
  },
  {
    name: 'Falta de permissão para o trabalho',
    value: 'permissao'
  },
  {
    name: 'Improvisação de ferramentas/equipamentos',
    value: 'improvisacao'
  },
  {
    name: 'Não utilização ou uso inadequado de EPI',
    value: 'sem_epi'
  },
  {
    name: 'Sem cinto de segurança, luzes desligadas ou velocidade superior a permitida',
    value: 'transito'
  },
  {
    name: 'Obstrução/ausência de equipamentos e/ou saídas de emergência',
    value: 'saidas'
  },
  {
    name: 'Operar equipamentos sem capacitação ou identificação',
    value: 'operacao_capacitacao'
  },
  {
    name: 'Posição inadequada oara tarefa (ex: embaixo de carga)',
    value: 'posicao'
  },
  {
    name: 'Postura inadequada',
    value: 'postura'
  },
  {
    name: 'Subir/Descer (ex: não usar corrimão, pular degrau)',
    value: 'subir'
  },
  {
    name: 'Uso de adorno (ex: anel, correntes, relógio, roupa solta)',
    value: 'adorno'
  },
  {
    name: 'Uso de ferramentas/equipamentos inadequados',
    value: 'item_inadequado'
  }
]

export const riscos = [
  {
    name: 'Ausência de sinalização no local',
    value: 'sinalizacao'
  },
  {
    name: 'Ausência ou deficiência de iluminação',
    value: 'iluminacao'
  },
  {
    name: 'Ausência ou deficiência de sistema de parada de emergência',
    value: 'sis_emergencia'
  },
  {
    name: 'Derramamentos/Vazamentos (ex: gases, poeira, vapores, liquidos)',
    value: 'derramamentos'
  },
  {
    name: 'Falta de trava quedas',
    value: 'trava_queda'
  },
  {
    name: 'Falta e/ou guarda-corpo inadequado',
    value: 'guarda_corpo'
  },
  {
    name: 'Manutenção deficiente de máquinas e equipamentos',
    value: 'manutencao'
  },
  {
    name: 'Máquinas sem os mecanismos de proteção',
    value: 'protecao'
  },
  {
    name: 'Obstrução/Ausência de equipamentos e/ou saída de emergência',
    value: 'saida_emergencia'
  },
  {
    name: 'Organização e limpeza (5S)',
    value: '5s'
  },
  {
    name: 'Pisos ou superfícies irregulares ou defeituosos',
    value: 'pisos'
  },
  {
    name: 'Ventilação inadequada',
    value: 'ventilacao'
  }
]

export const resolv = [
  {
    name: 'SIM',
    value: 'sim'
  },
  {
    name: 'NÃO',
    value: 'nao'
  }
]
